// extracted by mini-css-extract-plugin
module.exports = {"loader":"ButtonLoader_loader__1XFVo","squish-squares":"ButtonLoader_squish-squares__1dJTx","dark":"ButtonLoader_dark__zUzWh"};